import React, { useState, useEffect } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { supabase } from "../../utils/supabase";
import styled from "styled-components";

const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: var(--background-color);
`;

const LoadingText = styled.div`
  font-family: "Playfair Display", serif;
  color: var(--primary-color);
  font-size: 1.5rem;
  text-align: center;
`;

const PrivateRoute = () => {
  const { currentUser } = useAuth();
  const [checkingSession, setCheckingSession] = useState(true);
  const [sessionUser, setSessionUser] = useState(null);

  useEffect(() => {
    // Check if we have a session when the component mounts
    const checkSession = async () => {
      try {
        console.log("PrivateRoute - Checking session");
        const { data, error } = await supabase.auth.getSession();

        if (error) {
          console.error("PrivateRoute - Session error:", error);
        } else {
          console.log(
            "PrivateRoute - Session data:",
            data?.session ? "Session exists" : "No session"
          );
          setSessionUser(data?.session?.user || null);
        }
      } catch (err) {
        console.error("PrivateRoute - Error checking session:", err);
      } finally {
        setCheckingSession(false);
      }
    };

    checkSession();
  }, []);

  // If we're still checking the session, show a loading indicator
  if (checkingSession) {
    return (
      <LoadingContainer>
        <LoadingText>
          <p>Loading your experience...</p>
        </LoadingText>
      </LoadingContainer>
    );
  }

  // Use either the auth context user or the session user for verification
  const authenticatedUser = currentUser || sessionUser;

  return authenticatedUser ? <Outlet /> : <Navigate to="/login" replace />;
};

export default PrivateRoute;
